import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

function PrivateRoute({ component: Component, user, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                user? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/site/not-found" />
                )
            }
        />
    );
}

const mapStateToProps = (state) => ({
    user: state.user.userConnected.user?.isAdmin, // Assuming user state is stored in state.user
});

export default connect(mapStateToProps)(PrivateRoute);
